'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = require('./core');

var _service = require('./core/service');

var _debug = require('./utils/debug');

var _utils = require('./utils');

if (_debug.isDebugMode && !_utils.isServer) {
  window.tarot = _extends({}, (0, _core.getInternalObject)(), {
    service: _service.serviceStore
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL21vZHVsZXMvZXhwb3NlLmpzIl0sIm5hbWVzIjpbImlzRGVidWdNb2RlIiwiaXNTZXJ2ZXIiLCJ3aW5kb3ciLCJ0YXJvdCIsInNlcnZpY2UiLCJzZXJ2aWNlU3RvcmUiXSwibWFwcGluZ3MiOiI7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7QUFFQSxJQUFJQSxzQkFBZSxDQUFDQyxlQUFwQixFQUE4QjtBQUM1QkMsU0FBT0MsS0FBUCxnQkFDSyw4QkFETDtBQUVFQyxhQUFTQztBQUZYO0FBSUQiLCJmaWxlIjoiZXhwb3NlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ2V0SW50ZXJuYWxPYmplY3QgfSBmcm9tICcuL2NvcmUnXG5pbXBvcnQgeyBzZXJ2aWNlU3RvcmUgfSBmcm9tICcuL2NvcmUvc2VydmljZSdcbmltcG9ydCB7IGlzRGVidWdNb2RlIH0gZnJvbSAnLi91dGlscy9kZWJ1ZydcbmltcG9ydCB7IGlzU2VydmVyIH0gZnJvbSAnLi91dGlscydcblxuaWYgKGlzRGVidWdNb2RlICYmICFpc1NlcnZlcikge1xuICB3aW5kb3cudGFyb3QgPSB7XG4gICAgLi4uZ2V0SW50ZXJuYWxPYmplY3QoKSxcbiAgICBzZXJ2aWNlOiBzZXJ2aWNlU3RvcmVcbiAgfVxufVxuIl19